import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import {
    COUNTERPARTY_REVIEW_FIELD_LABELS,
    CounterpartyReviewField,
} from "@common/types/counterpartyFieldReview";
import { pluralize } from "@common/helpers/string";

interface CounterpartyReviewFilterLabelProps {
    filters: Pick<
        FiltersTypes,
        "counterpartyReviewedFields" | "counterpartyUnreviewedFields"
    >;
    mode: "reviewed" | "unreviewed";
}

function fieldLabels(fields: CounterpartyReviewField[]): string {
    if (fields.length === 0) {
        return "";
    }
    if (fields.length === 1) {
        return COUNTERPARTY_REVIEW_FIELD_LABELS[fields[0]];
    }
    return `${fields.length} ${pluralize("field", fields.length)}`;
}

export const CounterpartyReviewFilterLabel: React.FC<
    CounterpartyReviewFilterLabelProps
> = ({ filters, mode }) => {
    if (mode === "reviewed") {
        const reviewedFields = filters.counterpartyReviewedFields ?? [];
        return <>Reviewed: {fieldLabels(reviewedFields)}</>;
    }

    const unreviewedFields = filters.counterpartyUnreviewedFields ?? [];
    return <>Unreviewed: {fieldLabels(unreviewedFields)}</>;
};
